import { useState, useEffect } from "react";
import {
  Container,
  CircularProgress,
  Typography,
  IconButton,
  Button,
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
  useMediaQuery,
  useTheme,
  Badge,
  Tooltip,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  UpdateContractActive,
  UpdateContractVersion,
  CopyHHContract,
  FetchAlContractDocumentData,
  FetchCommentByContractVersionId,
  DeleteComment,
  FetchAdditionalFilesByContractVersionId,
  ReplyComment,
} from "../api/contractVersionService";
import { ACTION, STATUS, USERROLE } from "../utils/commonConstant";
import { DataGrid } from "@mui/x-data-grid";
import { HHCONTRACTSTATUSENUMTYPE } from "../utils/commonConstant";
import { fetchFromWebApi } from "../utils/fetchFromWebApi";
import "../App.css";
import toast from "react-hot-toast";
import HeaderLogo from "../components/LogoHeader";
import Download from "@mui/icons-material/Download";
import HistoryIcon from '@mui/icons-material/History';
import CommentIcon from "@mui/icons-material/Comment";
import PreviewIcon from "@mui/icons-material/Preview";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ConfirmationDialog from "../confirm/confirmation";
import FileUploadPopup from "../ModelPopup/FileUploadPopup";
import CommentDialogPopup from "../ModelPopup/CommentPopup";
import AdditionalFileViewPopup from "../ModelPopup/AdditionalFileViewPopup";
import AuditHistoryPopup from "../ModelPopup/AuditHistoryPopup";
import ContractPreviewPopup from "../ModelPopup/ContractPreviewPopup";
import ContractMarkelApproveRejectPopupModal from "../ModelPopup/ContractMarkelApproveRejectPopup";

const MarkelContractDocument = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [openFileUploadPopup, setOpenFileUploadPopup] = useState(false);
  const [fileuploadData, setFileUploadData] = useState(null);
  const [editData, setEditData] = useState({
    VersionName: "",
    HHApprovalStatus: "",
    InsurerApprovalStatus: "",
    COApprovalStatus: "",
    IsActive: false,
  });
  const { clientId, hhDocumentId } = useParams();
  const navigate = useNavigate();
  const approvalStatus = ["Pending", "Approved", "Rejected"];
  const [optionTemplateLibrary, setOptionTemplateLibrary] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [errors, setErrors] = useState({
    template: "",
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [rowToConfirm, setRowToConfirm] = useState(null);
  const [confirmHHDialogOpen, setConfirmHHDialogOpen] = useState(false);
  const [confirmIsActiveDialogOpen, setConfirmIActiveDialogOpen] =
    useState(false);
  const [confirmCOApprovalDialogOpen, setConfirmCOApprovalialogOpen] =
    useState(false);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
  });

  const [rows, setRows] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [comments, setComments] = useState([]);
  const [additionalFileOpen, setAdditionalFileOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [openPreview, setOpenPreview] = useState(false);
  const [elements, setElements] = useState([]);
  const [markelApproveRejectState, setMarkelApproveRejectState] = useState({
    openPreviewMarkelApproveReject: false,
    actionType: null,
    confirmDialogOpen: false,
    commentDialogOpen: false,
    selectedRow: null,
  });
  const [formData, setFormData] = useState({
    comment: "",
    markelName: "",
  });
  const [markelError, setMarkelError] = useState({
    markelName: false,
    errorMessage: "",
  });
  const [auditHistoryPopup, setAuditHistoryPopup] = useState({
    open: false,
    data: null,
  });
  // Define initial sort model
  const sortModel = [
    {
      field: "Status", // Sort by the Status column
      sort: "desc", // 'asc' for ascending order, 'desc' for descending
    },
  ];
  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 50,
      headerClassName: "bold-header",
    },
    {
      field: "VersionName",
      headerName: "Version Name",
      width: 240,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
    },

    // {
    //   field: "SubcontractorType",
    //   headerName: "Subcontractor Type",
    //   width: 140,
    //   align: "center",
    //   headerAlign: "center",
    //   headerClassName: "bold-header",
    // },
    // {
    //   field: "HHApprovalStatus",
    //   headerName: "HH Approval",
    //   width: 120,
    //   align: "center",
    //   headerClassName: "bold-header",
    //   headerAlign: "center",
    //   renderCell: (params) => (
    //       <Badge
    //         color={getBadgeColor(params.row.HHApprovalStatus)}
    //         badgeContent={params.row.HHApprovalStatus}
    //       />
    //   ),
    // },
    // {
    //   field: "InsurerApprovalStatus",
    //   headerName: "Insurer Approval",
    //   align: "center",
    //   headerAlign: "center",
    //   headerClassName: "bold-header",
    //   width: 120,
    //   renderCell: (params) => (
    //       <Badge
    //         color={getBadgeColor(params.row.InsurerApprovalStatus)}
    //         badgeContent={params.row.InsurerApprovalStatus}
    //       />
    //   ),
    // },
    // {
    //   field: "COApprovalStatus",
    //   headerName: "CO Approval",
    //   width: 120,
    //   align: "center",
    //   headerAlign: "center",
    //   headerClassName: "bold-header",
    //   renderCell: (params) => (
    //       <Badge
    //         color={getBadgeColor(params.row.COApprovalStatus)}
    //         badgeContent={params.row.COApprovalStatus}
    //       />
    //   ),
    // },
    // {
    //   field: "IsActive",
    //   headerName: "IsActive",
    //   width: 100,
    //   align: "center",
    //   headerClassName: "bold-header",
    //   headerAlign: "center",
    //   renderCell: (params) => (
    //       params.row.IsActive ? (
    //         <CheckIcon color="primary" />
    //       ) : (
    //         <CloseIcon color="error" />
    //       )
    //   ),
    // },
    {
      field: "TemplateName",
      headerName: "Template Name",
      width: 200,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
    },
    {
      field: "Status",
      headerName: "Status",
      width: 200,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
      renderCell: (params) => (
        <Badge
          color={getBadgeColor(params.row.Status)}
          badgeContent={params.row.Status}
        />
      ),
    },
    {
      field: "MarkelName",
      headerName: "Markel Name",
      width: 200,
      align: "center",
      headerAlign: "center",
      headerClassName: "bold-header",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      sortable: false,
      align: "center",
      headerClassName: "bold-header",
      headerAlign: "center",
      renderCell: (params) => (
        <Box>
          {params.row.IsAdditionalFile && (
            <Tooltip title="View Additional Files" arrow>
              <IconButton
                color="primary"
                onClick={() => handleFileIconClick(params.row)}
              >
                <InsertDriveFileIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.IsComment && (
            <Tooltip title="View Comment" arrow>
              <IconButton
                color="primary"
                onClick={() => handleCommentClick(params.row.Id)}
              >
                <CommentIcon />
              </IconButton>
            </Tooltip>
          )}
          {(params.row?.InsurerApprovalStatus === HHCONTRACTSTATUSENUMTYPE.PENDING ||
            params.row?.InsurerApprovalStatus === HHCONTRACTSTATUSENUMTYPE.REJECTED) && (
              <Tooltip title="Accept/Reject" arrow>
                <IconButton
                  color="primary" onClick={() => handlePreviewClick(params.row)}
                >
                  <PreviewIcon />
                </IconButton>
              </Tooltip>
            )}
          <Tooltip title="Download Pdf" arrow>
            <IconButton
              color="success"
              aria-label="Download PDF"
              onClick={() => handleDownloadContract(params.row)}
            >
              <Download />
            </IconButton>
          </Tooltip>
          <Tooltip title="Show Audit History" arrow>
            <IconButton
              color="primary"
              onClick={() => handleShowAuditHistory(params.row)}
            >
              <HistoryIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];
  const fetchData = async () => {
    try {
      const result = await FetchAlContractDocumentData(clientId, hhDocumentId);
      setData(result);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  const addIdToData = (data) => {
    // Create a new array with 'id' field added to each object
    return data.map((item) => ({ ...item, id: item.Id }));
  };

  useEffect(() => {
    fetchData();
  }, [clientId]);
  // Styles for the modal
  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    overflowY: "auto",
    maxHeight: "90vh",
  };

  useEffect(() => {
    const updatedRows = addIdToData(data);
    setRows(updatedRows);
    console.log(rows);
  }, [data]);

  if (loading) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Typography color="error">
          Error fetching data: {error.message}
        </Typography>
      </Container>
    );
  }

  const handleFileIconClick = async (row) => {
    console.log("Open file for:", row);
    // Handle file open logic here
    setAdditionalFileOpen(true);
    const data = await FetchAdditionalFilesByContractVersionId(row.Id);
    const dataWithid = data.map((file) => ({
      id: file.Id,
      ...file,
    }));
    setFiles(dataWithid);
  };
  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleEdit = () => {
    setEditData(selectedRow);
    setEditDialogOpen(true);
    handleMenuClose();
  };
  const handleCommentClick = async (id) => {
    const data = await FetchCommentByContractVersionId(id); // Fetch comments based on the row's ID
    setComments(data);
    setDialogOpen(true);
  };
  const handlePreviewClick = async (row) => {
    if (row?.InsurerApprovalStatus === HHCONTRACTSTATUSENUMTYPE.PENDING || row?.InsurerApprovalStatus === HHCONTRACTSTATUSENUMTYPE.REJECTED) {
      setElements(row.MetaData);
      setMarkelApproveRejectState((prevState) => ({
        ...prevState,
        openPreviewMarkelApproveReject: true,
        selectedRow: row,
      }));
      handleMenuClose();
    }
  };

  const handleActivateContract = async () => {
    console.log("Update Status:", rowToConfirm);
    const resp = await UpdateContractActive(rowToConfirm.Id);
    console.log("handleActivateContract :", resp);
    handleMenuClose();
    fetchData(); // Refresh data after update
    toast.success("Contract is activated successfully.");
    setConfirmIActiveDialogOpen(false);
  };
  const handleIsActiveToggle = async (row) => {
    setConfirmIActiveDialogOpen(true);
    setRowToConfirm(row);
  };
  const handleCopyContract = async () => {
    console.log("Update Status:", selectedRow);
    const resp = await CopyHHContract(selectedRow.Id);
    console.log("handleActivateContract :", resp);
    handleMenuClose();
    fetchData(); // Refresh data after update
    toast.success("Contract is copied successfully.");
  };
  const handleApproveReject = async () => {
    console.log("Update Status:", selectedRow.MetaData);
    // navigate(`/contract-document/${selectedRow.ClientId}/${selectedRow.Id}`);
    setElements(selectedRow.MetaData);
    //setSelectedRow(row);
    setMarkelApproveRejectState((prevState) => ({
      ...prevState,
      openPreviewMarkelApproveReject: true,
      selectedRow: selectedRow,
    }));

    handleMenuClose();
  };
  const handleSubmitForApproval = async () => {
    setFileUploadData(selectedRow);
    setOpenFileUploadPopup(true);
    handleMenuClose();
  };
  const handleFileUploadPopupClose = () => {
    setOpenFileUploadPopup(false);
    setFileUploadData(null);
  };

  // const handleBack = () => {
  //   window.history.back();
  // };
  const handleAutocompleteTemplateChange = (event, newValue) => {
    setErrors({ ...errors, template: "" });
    setSelectedOption(newValue);
  };
  const handleCreate = () => {
    //navigate(`/${clientId}/versions/${ACTION.CREATE}`);
    setTemplateDialogOpen(true);
  };
  const handleTemplate = () => {
    navigate(`/home`);
  };

  const handleEditDialogClose = () => {
    setEditDialogOpen(false);
  };
  const handleTemplateDialogClose = () => {
    setTemplateDialogOpen(false);
  };
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleAutocompleteChange = (event, newValue, fieldName) => {
    setEditData({ ...editData, [fieldName]: newValue });
  };

  const handleEditSave = async () => {
    try {
      console.log("Save Edit Data:", editData);
      const updatedContract = await UpdateContractVersion(
        editData.Id,
        editData
      );
      console.log("Save Edit:", updatedContract);
      fetchData(); // Refresh data after update
      // Optionally update state or handle success message
      toast.success("Updated successfully.");
    } catch (error) {
      // Handle error
    }
    setEditDialogOpen(false);
  };
  const handleTemplateSave = async () => {
    debugger;
    const newErrors = { ...errors };
    if (!selectedOption) {
      newErrors.template = "Template  is required";
      setErrors(newErrors);
      return;
    }
    setTemplateDialogOpen(false);
    console.log(selectedOption.Id);
    navigate(`/${clientId}/versions/${selectedOption.Id}/${ACTION.CREATE}`);
  };
  const handleDownloadContract = (row) => {
    // const currentUrl = window.location.href;
    // console.log(currentUrl)
    const baseURL = `${window.location.protocol}//${window.location.host}`;
    console.log(baseURL);

    const pdfDownloadUrl = `${process.env.REACT_APP_HHMANAGER_AWS_LAMBDA_PDF_URL}/?url=${baseURL}/${clientId}/download/${row.Id}`;
    console.log(pdfDownloadUrl, "pdfDownloadUrl");
    window.open(pdfDownloadUrl, "_blank");
  };

  const handleCopyUrl = (row) => {
    const currentUrl = window.location.href;
    const textToCopy = `${currentUrl}/download/${row.Id}`;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        toast.success(`URL copied to clipboard.`);
      })
      .catch((err) => {
        toast.error("Failed to copy URL: ", err);
      });
  };
  // const handleToggleHHApproval = async (row) => {
  //   const updatedStatus = row.HHApprovalStatus === 'Approved' ? 'Pending' : 'Approved';
  //   const updatedData = {
  //     ...row,
  //     HHApprovalStatus: updatedStatus
  //   };
  //   try {
  //     await UpdateContractVersion(row.Id, updatedData); // Assuming this function handles the API call to update the contract
  //     fetchData(); // Refresh data after update
  //     toast.success(`HH Approval Status updated to ${updatedStatus}`);
  //   } catch (error) {
  //     toast.error("Error updating HH Approval Status");
  //   }
  // };
  const handleToggleHHApproval = (row) => {
    setRowToConfirm(row);
    setConfirmHHDialogOpen(true);
  };
  const confirmToggleHHApproval = async () => {
    const updatedStatus =
      rowToConfirm.HHApprovalStatus === "Approved" ? "Pending" : "Approved";
    const updatedData = {
      ...rowToConfirm,
      HHApprovalStatus: updatedStatus,
    };
    try {
      await UpdateContractVersion(rowToConfirm.Id, updatedData); // Assuming this function handles the API call to update the contract
      fetchData(); // Refresh data after update
      toast.success(`HH Approval Status updated to ${updatedStatus}`);
    } catch (error) {
      toast.error("Error updating HH Approval Status");
    }
    setConfirmHHDialogOpen(false);
    setRowToConfirm(null);
  };
  // const handleToggleInsurerApproval = async () => {
  //   const updatedStatus = rowToConfirm.InsurerApprovalStatus === 'Approved' ? 'Pending' : 'Approved';
  //   const updatedData = {
  //     ...rowToConfirm,
  //     InsurerApprovalStatus: updatedStatus
  //   };
  //   try {
  //     await UpdateContractVersion(rowToConfirm.Id, updatedData); // Assuming this function handles the API call to update the contract
  //     fetchData(); // Refresh data after update
  //     toast.success(`Insurer Approval Status updated to ${updatedStatus}`);
  //   } catch (error) {
  //     toast.error("Error updating Insurer Approval Status");
  //   }
  //   setConfirmDialogOpen(false);
  //   setRowToConfirm(null);
  // };
  const handleToggleInsurerApproval = (row) => {
    setRowToConfirm(row);
    setConfirmDialogOpen(true);
  };

  const handleToggleCOApproval = (row) => {
    setRowToConfirm(row);
    setConfirmCOApprovalialogOpen(true);
  };
  const confirmToggleCOApproval = async () => {
    const updatedStatus =
      rowToConfirm.COApprovalStatus === "Approved" ? "Pending" : "Approved";
    const updatedData = {
      ...rowToConfirm,
      COApprovalStatus: updatedStatus,
    };
    try {
      await UpdateContractVersion(rowToConfirm.Id, updatedData); // Assuming this function handles the API call to update the contract
      fetchData(); // Refresh data after update
      toast.success(`CO Approval Status updated to ${updatedStatus}`);
    } catch (error) {
      toast.error("Error updating HH Approval Status");
    }
    setConfirmCOApprovalialogOpen(false);
    setRowToConfirm(null);
  };
  const confirmToggleInsurerApproval = async () => {
    const updatedStatus =
      rowToConfirm.InsurerApprovalStatus === "Approved"
        ? "Pending"
        : "Approved";
    const updatedData = {
      ...rowToConfirm,
      InsurerApprovalStatus: updatedStatus,
    };
    try {
      await UpdateContractVersion(rowToConfirm.Id, updatedData);
      fetchData(); // Refresh data after update
      toast.success(`Insurer Approval Status updated to ${updatedStatus}`);
    } catch (error) {
      toast.error("Error updating Insurer Approval Status");
    }
    setConfirmDialogOpen(false);
    setRowToConfirm(null);
  };
  const handleCloseConfirmationDialog = () => {
    setConfirmDialogOpen(false);
    setRowToConfirm(null);
  };
  const handleCloseComment = () => {
    setDialogOpen(false);
    setComments([]);
  };
  const handleDeleteComment = async (commentId, isReplyDelete) => {
    console.log(commentId);
    const resp = await DeleteComment(commentId);
    if (resp.ok) {
      toast.success(
        `Comment ${isReplyDelete ? "Reply" : ""} deleted  successfully.`
      );
    }
    //setComments((prevComments) => prevComments.filter(comment => comment.Id !== commentId));
  };
  const handleReplyComment = async (parentCommentId, comment) => {
    console.log(parentCommentId, comment);
    const resp = await ReplyComment({
      parentCommentId: parentCommentId,
      commentReply: comment,
      userId: localStorage.getItem("UserId"),
    });
    if (resp) {
      toast.success("Comment replied successfully.");
    }
  };
  const handleAdditionalFileClose = () => {
    setAdditionalFileOpen(false);
    handleMenuClose();
  };
  const handleClosePreview = () => {
    setOpenPreview(false);
    setElements([]);
  };

  const handleClosePreviewMarkelApproveReject = () => {
    setElements([]);
    setSelectedRow(null);
    setMarkelApproveRejectState((prevState) => ({
      ...prevState,
      openPreviewMarkelApproveReject: false,
    }));
  };

  const handelConfirmOpenMarkelApproveReject = async (actionType, row) => {
    if (actionType === STATUS.APPROVED) {
      const trackChangeelements = document.querySelectorAll(".track-changes");

      for (const element of trackChangeelements) {
        if (element.dataset.status === "Created") {
          const spanElement = document.querySelector(
            `span[data-change-id="${element.dataset.changeId}"]`
          );
          if (spanElement) {
            spanElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          toast.error(
            "Client does not resolved all track changes. Please wait for client approval."
          );

          return;
        } else if (element.dataset.status === "Pending") {
          const spanElement = document.querySelector(
            `span[data-change-id="${element.dataset.changeId}"]`
          );
          if (spanElement) {
            spanElement.scrollIntoView({ behavior: "smooth", block: "center" });
          }
          let errorMessage = element.dataset.actionType.toLowerCase() === 'rejected' ? 'Form cannot be approved due to rejected comments.' : 'Please resolve all track changes before proceeding.'
          toast.error(errorMessage);
          return;
        }
      }
    }
    setMarkelApproveRejectState((prevState) => ({
      ...prevState,
      actionType: actionType,
      confirmDialogOpen: true,
    }));

    console.log("ELEMENTS UPDATED FRO ", elements);
  };

  const handleCloseConfirmationDialogMarkelApproveReject = () => {
    setMarkelApproveRejectState((prevState) => ({
      ...prevState,
      confirmDialogOpen: false,
    }));
  };

  const confirmToggle = async () => {
    debugger;
    if (
      markelApproveRejectState.actionType &&
      markelApproveRejectState.selectedRow
    ) {
      setMarkelApproveRejectState((prevState) => ({
        ...prevState,
        confirmDialogOpen: false,
        commentDialogOpen: true,
      }));
    }
  };

  const handleCommentDialogClose = () => {
    setMarkelApproveRejectState((prevState) => ({
      ...prevState,
      commentDialogOpen: false,
    }));
    setFormData({
      comment: "",
      markelName: "",
    });
    setMarkelError({
      markelName: false,
      errorMessage: "",
    });
  };

  const handleResetMarkelApprovalRejectState = () => {
    setMarkelApproveRejectState({
      openPreviewMarkelApproveReject: false,
      actionType: null,
      confirmDialogOpen: false,
      commentDialogOpen: false,
      selectedRow: null,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "markelName" && value) {
      setMarkelError({ markelName: false, errorMessage: "" });
    }
  };

  const getAllComments = (elements) => {
    const commentClass = document.querySelectorAll(".selection-highlight");
    const newComments = [];
    elements.forEach(element => {
      var tcComments = element.props.trackChangesComments;
      if (tcComments && Object.keys(tcComments).length !== 0) {
        Object.keys(tcComments).forEach(key => {
          let changes = tcComments[key];
          changes?.forEach(change => {
            if (change.userRole && (change.userRole === 'Markel')) {
              newComments.push(change);
            }
          })
        });
      }
    });
    return commentClass.length + newComments.length ?? 0;
  };

  const handleAction = async (actionType, elements, comment, markelName) => {
    console.log("ELEMENTS FROM HANDLEACTION", elements);
    try {
      const res = await fetchFromWebApi(
        `HHContract/MarkelApproveRejectContractDocument`,
        {
          method: "POST",
          body: JSON.stringify({
            contractVersionId: markelApproveRejectState.selectedRow.Id,
            isApproved: actionType === STATUS.APPROVED ? true : false,
            comment: comment,
            userId: localStorage.getItem("UserId"),
            markelName: markelName,
            metaData: elements,
            noOfComments: getAllComments(elements)
          }),
        }
      );
      setLoading(false);
      if (res?.ok) {
        toast.success(
          `Contract ${markelApproveRejectState.actionType} successfully.`
        );
        handleResetMarkelApprovalRejectState();
        setElements([]);
        fetchData();
        navigate("/thank-you-markel");
      } else {
        console.error("Failed to save form:", await res.text());
        toast.error("Failed to sign contract:", await res.text());
      }
    } catch (error) {
      setLoading(false);
      toast.error(`Failed to ${actionType} contract.`);
    }
  };

  const handleCommentSubmit = () => {
    console.log("Comment:", formData.comment);
    if (
      markelApproveRejectState.actionType === STATUS.REJECTED &&
      !formData.comment.trim()
    ) {
      toast.error("Comment is mandatory if the document is rejected.");
      return;
    }
    if (!formData.markelName) {
      setMarkelError({
        markelName: true,
        errorMessage: "Markel Name is required",
      });
      return;
    }
    handleAction(
      markelApproveRejectState.actionType,
      elements,
      formData.comment,
      formData.markelName
    );
    handleCommentDialogClose();
    if (markelApproveRejectState.openPreviewMarkelApproveReject) {
      setMarkelApproveRejectState((prevState) => ({
        ...prevState,
        openPreviewMarkelApproveReject: false,
      }));
    }
  };

  const handleShowAuditHistory = async (row) => {
    setAuditHistoryPopup((prev) => ({ ...prev, open: true, data: row }));
  };

  const getBadgeColor = (status) => {
    switch (status) {
      case "Approved":
        return "success";
      case "Pending":
        return "warning";
      case "Rejected":
        return "error";
      default:
        return "default";
    }
  };
  return (
    <>
      <Box sx={{ padding: 2 }}>
        <HeaderLogo clientId={clientId} />
        <Container>
          <Grid
            container
            //justifyContent="space-between"
            justifyContent="flex-end"
            alignItems="center"
            mb={2}
            spacing={2}
          >
            <Grid item justifyContent="flex-end">
              <Button
                variant="contained"
                color="primary"
                onClick={handleTemplate}
              >
                Home
              </Button>
            </Grid>
          </Grid>
          {/* <Paper> */}
          {/* <Box sx={{ height: 500, width: "100%" }}> */}
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10, 50, 100]}
            disableSelectionOnClick // Disable row selection
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            sortModel={sortModel} // Set initial sort model
          />
        </Container>
      </Box>
      {/* model popup for edit */}
      <Dialog
        open={editDialogOpen}
        onClose={handleEditDialogClose}
        maxWidth="md"
        fullWidth={fullScreen}
      >
        <DialogTitle>Edit Contract Version</DialogTitle>
        <DialogContent sx={{ width: fullScreen ? "100%" : "600px" }}>
          <TextField
            margin="dense"
            name="VersionName"
            label="Version Name"
            type="text"
            fullWidth
            value={editData.VersionName}
            onChange={handleEditChange}
          />
          <Autocomplete
            options={approvalStatus}
            readOnly
            value={editData.HHApprovalStatus}
            onChange={(event, newValue) =>
              handleAutocompleteChange(event, newValue, "HHApprovalStatus")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                readOnly
                label="HH Approval Status"
                margin="dense"
                fullWidth
              />
            )}
          />
          <Autocomplete
            options={approvalStatus}
            readOnly
            value={editData.InsurerApprovalStatus}
            onChange={(event, newValue) =>
              handleAutocompleteChange(event, newValue, "InsurerApprovalStatus")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                readOnly
                label="Insurer Approval Status"
                margin="dense"
                fullWidth
              />
            )}
          />
          <Autocomplete
            options={approvalStatus}
            readOnly
            value={editData.COApprovalStatus}
            onChange={(event, newValue) =>
              handleAutocompleteChange(event, newValue, "COApprovalStatus")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                readOnly
                label="CO Approval Status"
                margin="dense"
                fullWidth
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleEditSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* confirmation for Insurer Approval  */}
      <ConfirmationDialog
        open={confirmDialogOpen}
        onClose={handleCloseConfirmationDialog}
        onConfirm={confirmToggleInsurerApproval}
        message={`Are you sure you want to toggle Insurer Approval Status for ${rowToConfirm ? rowToConfirm.VersionName : ""
          }?`}
      />
      {/* confirmation for HH Approval  */}
      <ConfirmationDialog
        open={confirmHHDialogOpen}
        onClose={() => setConfirmHHDialogOpen(false)}
        onConfirm={confirmToggleHHApproval}
        message={`Are you sure you want to toggle HH Approval Status for ${rowToConfirm?.VersionName}?`}
      />
      {/* confirmation for Activate contract  */}

      <ConfirmationDialog
        open={confirmIsActiveDialogOpen}
        onClose={() => setConfirmIActiveDialogOpen(false)}
        onConfirm={handleActivateContract}
        message={`Are you sure you want to Activate contract for ${rowToConfirm?.VersionName}?`}
      />

      {/* confirmation for   */}
      <ConfirmationDialog
        open={confirmCOApprovalDialogOpen}
        onClose={() => setConfirmCOApprovalialogOpen(false)}
        onConfirm={confirmToggleCOApproval}
        message={`Are you sure you want to toggle CO Approval Status for ${rowToConfirm?.VersionName}?`}
      />
      {/* model popup for template select   */}
      <Dialog
        open={templateDialogOpen}
        onClose={handleTemplateDialogClose}
        maxWidth="md"
        fullWidth={fullScreen}
      >
        <DialogTitle> Template</DialogTitle>
        <DialogContent sx={{ width: fullScreen ? "100%" : "600px" }}>
          <Autocomplete
            options={optionTemplateLibrary}
            value={selectedOption}
            getOptionLabel={(option) => option.Name}
            isOptionEqualToValue={(option, value) =>
              option.valueOf === value.valueOf
            }
            onChange={(event, newValue) =>
              handleAutocompleteTemplateChange(event, newValue)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Template"
                margin="dense"
                fullWidth
                error={!!errors.template}
                helperText={errors.template || ""}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTemplateDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleTemplateSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <FileUploadPopup
        open={openFileUploadPopup}
        onClose={handleFileUploadPopupClose}
        data={fileuploadData}
      />
      <CommentDialogPopup
        open={dialogOpen}
        onClose={handleCloseComment}
        comments={comments}
        onDelete={handleDeleteComment}
        onReply={handleReplyComment}
      />
      <AdditionalFileViewPopup
        open={additionalFileOpen}
        onClose={handleAdditionalFileClose}
        files={files}
      />

      <ContractPreviewPopup
        open={openPreview}
        onClose={handleClosePreview}
        elements={elements}
        clientId={clientId}
        previewTitle={"Form Contract"}
        isSignatureDisabled={true}
        trackChangeDisplayBy={USERROLE.MARKEL}
        isShowTrackHistory={true}
      />

      <ContractMarkelApproveRejectPopupModal
        open={markelApproveRejectState.openPreviewMarkelApproveReject}
        onClose={handleClosePreviewMarkelApproveReject}
        elements={elements}
        handleConfirmOpen={handelConfirmOpenMarkelApproveReject}
        selectedRow={selectedRow}
        clientId={clientId}
        setElements={setElements}
      />

      <AuditHistoryPopup
        open={auditHistoryPopup.open}
        onClose={() =>
          setAuditHistoryPopup((prev) => ({ ...prev, open: false, data: null }))
        }
        contractVersionId={auditHistoryPopup?.data?.Id}
      />

      <ConfirmationDialog
        open={markelApproveRejectState.confirmDialogOpen}
        onClose={handleCloseConfirmationDialogMarkelApproveReject}
        onConfirm={confirmToggle}
        message={`Are you sure you want to [ ${markelApproveRejectState.actionType} ] ${markelApproveRejectState?.selectedRow?.VersionName} Contract Document ?`}
      />

      <Dialog
        open={markelApproveRejectState.commentDialogOpen}
        onClose={handleCommentDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Write a Comment</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="comment"
            name="comment"
            label="Comment"
            type="text"
            fullWidth
            multiline
            rows={5}
            value={formData.comment}
            onChange={handleInputChange}
            placeholder="Write your comment here..."
          />
          <TextField
            autoFocus
            margin="dense"
            id="markelName"
            name="markelName"
            label="Markel Name"
            type="text"
            fullWidth
            value={formData.markelName}
            onChange={handleInputChange}
            error={markelError.markelName}
            helperText={markelError.markelName ? markelError.errorMessage : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCommentDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCommentSubmit} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MarkelContractDocument;
